import React, { FC, useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Image from "componentsTemplate/Image";
import { getHomeBanners } from "services/PageService";

export interface HomeBannerProps {
  institutional?: any;
}

const HomeBanner: FC<HomeBannerProps> = () => {
  const urlBase =
    process.env.REACT_APP_BACKEND_API_URL +
    "/storage/images/institutional/home-banners/";

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [banners, setBanners] = useState<any[]>([]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const fetchInstitutional = async () => {
    try {
      const data = await getHomeBanners();
      setBanners(data);
    } catch (error) {
      console.error("Erro ao carregar os dados", error);
    }
  };

  useEffect(() => {
    fetchInstitutional();
  }, []);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const verificarseEstaNoModoMobile = () => {
    if (windowWidth < 768) {
      return "200px";
    }
    return "100%";
  };

  return (
    <div className="SectionHero2 relative">
      <Slider {...settings}>
        {banners.map((item: any, index: number) => (
          <div key={index} style={{ width: "100%", height: "auto" }}>
            {item.link ? (
              <a href={item.link} target="_blank" rel="noopener noreferrer">
                <Image
                  className="object-cover"
                  src={urlBase + item.banner_path}
                  style={{ height: verificarseEstaNoModoMobile() }}
                  alt="hero"
                />
              </a>
            ) : (
              <Image
                className="object-cover"
                src={urlBase + item.banner_path}
                style={{ height: verificarseEstaNoModoMobile() }}
                alt="hero"
              />
            )}
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default HomeBanner;
